// src/components/Footer.js
import React, { useEffect, useState } from 'react';
import { Button ,Container,Offcanvas,Row,Col,Nav} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { db } from '../FireBase'; // Adjust the import based on your Firebase config
import { collection, getDocs } from 'firebase/firestore';
import { FaEnvelope, FaFacebook, FaInbox, FaInstagram, FaPhone } from 'react-icons/fa';
import Feedback from "../components/Feedback"; // import your feedback component

const Footer = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [language] = useState(localStorage.getItem('language') || 'en'); // Default to English
  const fontSizeClassFooter = language === 'ta' ? 'font-size-tamil-footer' : 'font-size-default-nav';
  const [address,setAddress]= useState('');
  const [phone,setPhone]= useState('');
  const [email,setEmail]= useState('');
  const [facebook,setFacebook]= useState('');
  const [instagram,setInstagram]= useState('');
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const handleFeedbackOpen = () => {
    // Assuming handleClose is closing menu etc
    setFeedbackVisible(true);
  };
  const handleFeedbackClose = () => setFeedbackVisible(false);

  const handleResize = () => {
    // Set footer visibility based on window size
    if (window.innerWidth <= 768) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    // Set initial visibility
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Fetch address from Firestore
    const fetchAddress = async () => {
      try {
        const addressCollection = collection(db, 'settings'); // Change collection name as needed
        const addressSnapshot = await getDocs(addressCollection);
        if (!addressSnapshot.empty) {
          const addressData = addressSnapshot.docs[0].data();
          setAddress(addressData.address || 'No address available');
          setPhone(addressData.phone);
          setEmail(addressData.email);
          setFacebook(addressData.facebook);
          setInstagram(addressData.instagram);

        }
      } catch (error) {
        console.error('Error fetching address:', error);
      }
    };

    fetchAddress();
  }, []);


  return (
    <>
    {isVisible && (
    <footer className="footer">
      <div className="container" style={{padding:'30px 0px 30px 0px'}} >
        <Row>
        <Col style={{alignItems:'center',alignContent:'center'}}>
        {/* <img  src="/Logo.png" alt="Logo" className='logo-size-footer' />  */}
        <h1>Kabili Holidays</h1>
    
          </Col>
          <Col>
            <h5 style={{textAlign:'start',color:'#54b435'}}>Quick Links</h5>
            <hr/>
            <ul>
           
              <li>
                <Nav.Link as={Link} to="/"  className="d-flex  me-3 nav-link-own-footer " >
                  <span className={fontSizeClassFooter}>Home</span>
                </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/account" className="d-flex align-items-center me-3 nav-link-own-footer fontSizeClassNav">
                <span className={fontSizeClassFooter}>Account</span>
                </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/contact" className="d-flex align-items-center me-3 nav-link-own-footer fontSizeClassNav">
                <span className={fontSizeClassFooter}>Contact</span>
                </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/about" className="d-flex align-items-center me-3 nav-link-own-footer fontSizeClassNav" >
                <span className={fontSizeClassFooter}>About</span>
                </Nav.Link>
              </li>
              <li>
                    <Nav.Link  onClick={handleFeedbackOpen}   className="d-flex align-items-center me-3 nav-link-own-footer fontSizeClassNav" >
                    <span className={fontSizeClassFooter}>Feedback</span>
                </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/termsandcondition"  className="d-flex  me-3 nav-link-own-footer " >
                  <span className={fontSizeClassFooter}>Terms and conditions</span>
                </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/privacy-policy" className="d-flex align-items-center me-3 nav-link-own-footer fontSizeClassNav">
                <span className={fontSizeClassFooter}>Privacy policy</span>
                </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/cancellation-policy" className="d-flex align-items-center me-3 nav-link-own-footer fontSizeClassNav">
                <span className={fontSizeClassFooter}>Cancellation policy</span>
                </Nav.Link>
              </li>
             
            </ul>
          </Col>
        
          <Col>
            <h5 style={{textAlign:'start',color:'#54b435'}}>Contact</h5>
            <hr/>
            <div className='contact-details'>
            <p style={{whiteSpace: 'pre-wrap',textAlign:'left' }}>
            
              {address}
              
            </p>
            <p style={{textAlign:'left'}}><br/>
            <a className='nav-link-own-footer' style={{textDecoration:'none'}} href={`tel:${phone}`}><FaPhone/> {phone}</a><br />
            <a className='nav-link-own-footer' style={{textDecoration:'none'}}href={`mailto:${email}`}><FaEnvelope/> {email}</a><br /><br/>
            {facebook && 
             <a className='nav-link-own-footer' style={{textDecoration:'none',padding:'5px'}}href={facebook} target='_blank'><FaFacebook size={25}/></a>

            }
            {instagram &&
              <a className='nav-link-own-footer' style={{textDecoration:'none',padding:'5px'}}href={instagram} target='_blank'><FaInstagram size={25}/></a>
            }           
            </p>
            </div>
          </Col>
        </Row>
    
       
      </div>
   <div>
   <span className='nav-link-own-footer' style={{marginBottom:'none'}}>&copy;
        2025 all rights reserved 
        {/* {language === 'en' ? "2024 Narmadha Pathippagam. All Rights Reserved." : "2024 நர்மதா பதிப்பகம். அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை."} */}
          </span>
   </div>
    </footer>
    )}
      <Feedback show={feedbackVisible} onClose={handleFeedbackClose} />
    </>
  );
};

export default Footer;
